import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import TableChartOutlinedIcon from '@mui/icons-material/TableChartOutlined'
import {
  Box,
  Collapse,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material'
import React, { useState } from 'react'
import type { TableData } from '../../shared/types'

export default function TableBlock({ data }: { data: TableData }) {
  const [open, setOpen] = useState(false)
  const rowCount = data.rows.length
  const toggle = () => setOpen((v) => !v)

  return (
    <Box sx={{ my: 0.75 }}>
      <Box
        role="button"
        tabIndex={0}
        aria-expanded={open}
        onClick={toggle}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle() }
        }}
        sx={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: 0.75,
          cursor: 'pointer',
          color: 'text.secondary',
          px: 1,
          py: 0.5,
          borderRadius: 1,
          border: 1,
          borderColor: 'divider',
          userSelect: 'none',
          '&:hover': { bgcolor: 'action.hover' },
        }}
      >
        <TableChartOutlinedIcon fontSize="small" />
        <Typography variant="caption">
          {open ? 'Hide data table' : `Show data table (${rowCount} ${rowCount === 1 ? 'row' : 'rows'})`}
        </Typography>
        <ExpandMoreIcon
          fontSize="small"
          sx={{ transform: open ? 'rotate(180deg)' : 'none', transition: 'transform 0.2s' }}
        />
      </Box>
      <Collapse in={open} timeout="auto" unmountOnExit={true}>
        <TableContainer
          sx={{ mt: 0.75, maxHeight: 320, border: 1, borderColor: 'divider', borderRadius: 1 }}
        >
          <Table size="small" stickyHeader={true}>
            <TableHead>
              <TableRow>
                {data.columns.map((c) => (
                  <TableCell key={c} sx={{ fontWeight: 600, whiteSpace: 'nowrap' }}>{c}</TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {data.rows.map((row, i) => (
                <TableRow key={i} hover={true}>
                  {data.columns.map((c) => (
                    <TableCell key={c} sx={{ whiteSpace: 'nowrap' }}>{String(row[c] ?? '')}</TableCell>
                  ))}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Collapse>
    </Box>
  )
}
